import { DEFAULT_BRANDING } from 'src/config/constants.ts'

export default function checkBranding ({ from, to, store }) {
  const givenBranding = to.query.branding?.toUpperCase()

  // already logged in / non-public page / not the first page => ignore
  // branding already set => avoid infinite loop
  if (store.state.authToken || !to.meta.isPublic || from.name || to.query.cancel) {
    return
  }

  // reset the branding entry page
  // -> to give a chance to reset branding
  // -> to avoid updating all external website links to ?branding=DEFAULT
  if (!Object.keys(to.query).length && to.path === '/') {
    // TODO quick-fix: Do not reset branding for BID, fixes PWA and gives us time to fix it
    // REMOVE THIS AGAIN
    const currentBranding = store.getters['schoolBranding/getBranding']
    if (currentBranding?.toLowerCase() === 'bid') return

    store.commit('schoolBranding/SET_BRANDING', { app_branding: DEFAULT_BRANDING })
    store.dispatch('schoolBranding/loadLanguageVariables')
    return
  }

  // if no branding is given ignore
  if (!givenBranding) return

  // allow custom branding for public pages
  store.commit('schoolBranding/SET_BRANDING', { app_branding: givenBranding })
  store.dispatch('schoolBranding/loadLanguageVariables')

  if (to.path === '/data-protection') return false

  // params: cancel-bool prevents endless redirect
  // query: prevent endless loop + prevent resetting branding (see reset branding above)
  return {
    name: to.name,
    params: { ...to.params },
    query: { ...to.query, branding: undefined, [givenBranding]: !!givenBranding || undefined, cancel: true }
  }
}
